import React, {useState} from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {ChevronIcon, Heading, Link} from '@edume/magnificent';

import * as managerInsightsActions from '../../../state/managerInsights/managerInsightsActions';
import ChangeStoreList from '../ChangeStoreList';
import SearchBar from '../SearchBar';
import StoreInfoBar from '../StoreInfoBar';

import styles from './styles.module.scss';

const mapStateToProps = (state) => {
  const subTeams =
    state.managerInsights.getIn(['insights', 'summary', 'subTeams'])?.toJS() ||
    [];

  const stores = Object.keys(subTeams).map((key) => ({
    id: subTeams[key].id,
    name: subTeams[key].value,
  }));

  return {
    stores,
    selectedStoreId: state.managerInsights.get('selectedStoreId'),
    details: state.managerInsights.getIn(['insights', 'details']).toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

function Header({
  onClickBack,
  title,
  search,
  isModeSearch,
  value,
  onModeChange,
  onChange,
  stores,
  selectedStoreId,
  selectStoreForManagerInsights,
  details,
}) {
  const [isStoreSelectionModalVisible, setIsStoreSelectionModalVisible] =
    useState(false);
  const teamName = details.teamName;

  return (
    <>
      <div styleName='header'>
        <div styleName='header-inner'>
          {onClickBack && (
            <div styleName='back-button'>
              <Link
                icon={
                  <ChevronIcon colour='white' size='small' orientation='left' />
                }
                iconPosition='start'
                linkColour='white'
                linkSize='ant'
                onClick={onClickBack}
                text='Back'
              />
            </div>
          )}
          <Heading
            as='h1'
            colour='white'
            size='hamster'
            textTransform='none'
            weight='semiBold'
          >
            {title}
          </Heading>
          {search && (
            <div
              styleName={classNames('header-search-bar', {
                'header-search-bar-active': isModeSearch,
              })}
            >
              <SearchBar
                isHeaderView={true}
                isModeSearch={isModeSearch}
                value={value}
                onModeChange={onModeChange}
                onChange={onChange}
              />
            </div>
          )}
          {stores.length > 0 && (
            <button
              styleName='market-place-button'
              onClick={() => setIsStoreSelectionModalVisible(true)}
            >
              <img
                src='/resources/img/market-place-icon.svg'
                width={56}
                alt=''
              />
            </button>
          )}
        </div>
      </div>
      {isStoreSelectionModalVisible && (
        <ChangeStoreList
          onClose={() => setIsStoreSelectionModalVisible(false)}
          stores={stores}
          selectedStoreId={selectedStoreId}
          selectStore={selectStoreForManagerInsights}
          teamName={teamName}
        />
      )}
      {selectedStoreId && (
        <StoreInfoBar
          stores={stores}
          selectedStoreId={selectedStoreId}
          resetStore={() => selectStoreForManagerInsights(null)}
          teamName={teamName}
        />
      )}
    </>
  );
}

Header.propTypes = {
  details: PropTypes.object,
  onClickBack: PropTypes.func,
  title: PropTypes.string,
  search: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onModeChange: PropTypes.func,
  isModeSearch: PropTypes.bool,
  stores: PropTypes.array,
  selectedStoreId: PropTypes.number,
  selectStoreForManagerInsights: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSSModules(Header, styles, {allowMultiple: true}));
